import React, { useEffect } from 'react';
 
 
 const Getintouch = ()=>{

   const color= "#ffb472";


   useEffect(() => {
    document.querySelector('#outer-main').style.display="none"
    
    document.body.style.backgroundColor = color ;
}, []);

    return(
    
<>
       
<section id="subViews">

<div><img src="/assets/images/front-getintouch-link.png" alt="img" /></div>
<div className="children">
    <div className="sub-headline">There for you and care for you</div>
    <div className="sub-text-getintouch">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</div>

    <div id="link-image">

       <div>
         <div><img src="/assets/images/getintouch-small.png" /></div>
         <div>et@gmail.com</div>
       </div>

       <div>
         <div><img src="/assets/images/maintainable-small.png" /></div>
         <div>to@gmail.com</div>
       </div> 

       <div>
         <div><img src="/assets/images/whatwedo-small.png" /></div>
         <div>tre@gmail.com</div>
       </div>    
    </div>
    <div id="bottom"><div>getInTouch</div></div>
    </div>
</section>
</>

    )
    
    }
    
    export default Getintouch;

  